import { BtnSwitch } from './utilities/switch.js';

const IS_SHOW_CASE_SEARCH = 2;
const IS_SHOW_KJ_SEARCH = 3;
const __xushusSearch = {
    clickCount: 0,
    closeJz() {
        layer.closeAll()
    },
    showOpen1() {
        layer.open({
            type: 1,
            closeBtn: 0,
            shadeClose: false,
            title: false,
            btn: false,
            shadeClose:true,
            area: ['860px', '500px'],
            content: `<div class="modal-content" style="text-align:center;">
                                    <div class="moadle-renzheng-text">
                                        <div class="xq-header">中国青年科技奖介绍<img class="closeJzimg" src="/vendors/images/closeJz.png" /></div>
                                        <p class="xq-1" >1987年，为鼓励青年人才脱颖而出，解决科技人才青黄不接问题，在钱学森等老一辈科学家的倡导下，设立“中国科协青年科技奖”，1988年开展第一届评选表彰，1994年更名为“中国青年科技奖”。 </p>
                                        <p class="xq-2">中国青年科技奖由中共中央组织部、人力资源社会保障部、中国科协、共青团中央共同主办，旨在表彰在国家经济发展、社会进步和科技创新中作出突出贡献的青年科技人才，激发创新创业创造热情，培养造就规模宏大的青年科技人才队伍，打造大批一流科技领军人才和创新团队，为加快建设世界重要人才中心和创新高地、实现高水平科技自立自强贡献智慧和力量。</p>
                                        <p class="xq-3"> 中国青年科技奖评选周期为2年，每届中国青年科技奖获奖者不超过100名，由当届获奖者中产生中国青年科技奖特别奖获奖者不超过10名。该奖项已评选16届，共有1595位青年科技工作者获此殊荣，是我国科技创新的重要力量，其中近190位获奖者当选为两院院士。</p>
                                    </div>
                                </div>`,
        });
    },
    showOpen3() {
        layer.open({
            type: 1,
            closeBtn: 0,
            shadeClose: false,
            title: false,
            btn: false,
            shadeClose:true,
            area: ['860px', '500px'],
            content: `<div class="modal-content" style="text-align:center;">
                                    <div class="moadle-renzheng-text">
                                        <div class="xq-header">全国创新争先奖介绍<img class="closeJzimg" src="/vendors/images/closeJz.png" /></div>
                                        <p class="xq-1" >为深入贯彻落实习近平总书记在“科技三会”上的重要讲话精神，广泛开展创新争先行动，进一步团结引领广大科技工作者在建设世界科技强国进程中奋勇争先砥砺建功，树立新时代国家科技创新领域的楷模，2017年经中央批准，设立全国创新争先奖。 </p>
                                        <p class="xq-2">全国创新争先奖由中国科协、科技部、人力资源社会保障部、国务院国资委共同主办，表彰在基础研究和前沿探索、重大装备和工程攻关、成果转化和创新创业、社会服务等方面作出突出贡献的集体和个人。评选周期为3年，2017年开展首届评选表彰，2020年开展第二届评选表彰。</p>
                                        <p class="xq-3"> 表彰名额和范围为：先进集体不超过10个，表彰作出突出贡献的优秀科技工作者团队，颁发全国创新争先奖牌；先进个人不超过300名，表彰作出突出贡献的优秀科技工作者，颁发全国创新争先奖状；对其中不超过30名作出重大贡献的科技工作者，颁发全国创新争先奖章。</p>
                                    </div>
                                </div>`,
        });
    },
    showOpen2() {
        layer.open({
            type: 1,
            closeBtn: 0,
            shadeClose: false,
            title: false,
            btn: false,
            shadeClose:true,
            area: ['860px', '500px'],
            content: `<div class="modal-content" style="text-align:center;">
                                    <div class="moadle-renzheng-text">
                                        <div class="xq-header">中国青年女科学家奖介绍<img class="closeJzimg" src="/vendors/images/closeJz.png" /></div>
                                        <p class="xq-1" >中国青年女科学家奖由中国科协、全国妇联、中国联合国教科文组织全国委员会共同主办，旨在表彰面向世界科技前沿、面向经济主战场、面向国家重大需求、面向人民生命健康，在相关科技创新领域作出突出贡献的青年女科技工作者和团队，激发广大女科技工作者的创新创业创造热情，大力弘扬科学家精神，为加快建设世界重要人才中心和创新高地、实现高水平科技自立自强贡献智慧和力量。</p>
                                        <p class="xq-3"> 中国青年女科学家奖评选周期为1年，已评选表彰16届，共有144位女科学家和5个科技工作者团队获此殊荣，获奖者活跃在科学研究和技术创新一线，瞄准学科发展前沿，在各自的研究领域取得了丰硕成果，是广大女科技工作者中的优秀代表，其中谢毅、黄如、于吉红、曹晓风、陈化兰、王小云、吴骊珠、朱美芳、陈薇当选为两院院士。</p>
                                    </div>
                                </div>`,
        });
    },
    // 切换高级搜索下拉的状态
    toggleAdvanceSearch() {
        let $this = $(this);
        let index = $this.attr('data-index');
        let $searchCasePanel = $('#_highCaseSearchPanel');

        if (+index === IS_SHOW_CASE_SEARCH) {
            __xushusSearch.clickCount % 2 === 0 ? $searchCasePanel.show() : $searchCasePanel.hide();
        } else {
            $searchCasePanel.hide();
        }
        __xushusSearch.clickCount++;
    },
    resetHighSearchParam() {
        // 切换的时候重置高级搜索的部分
        $("._advancePanel").hide();
        __xushusSearch.clickCount = 0;
        $("#_showInAdvancedSearch").find("form").each((index, item) => {
            item.reset();
        });
    },
    // 点击单选按钮操作
    handleChangeRadio() {
        let $this = $(this);
        let $currRadioBtn = $this.find('.radio');
        // 清除掉前一项的选中状态

        if (__xushusSearch.$prevRadioBtn) {
            __xushusSearch.$prevRadioBtn.removeClass('checked');
        }
        $this
            .find('input[type=radio]').prop("checked", true);
        $currRadioBtn.addClass('checked');
        __xushusSearch.$prevRadioBtn = $currRadioBtn;

    },
    init() {
        new BtnSwitch({
            activeCls: 'active',
            parentCls: '._btnList',
            itemCls: 'li',
            defaultIndex: 0, // 默认显示的元素
            changeIndex(index) {
                let $highLevelSearch = $("._advancedSearch"),
                    $microphone = $("._microphone"),
                    $searchType = $("._searchKjList");

                if (index === IS_SHOW_CASE_SEARCH) {
                    $highLevelSearch.show().attr('data-index', index);
                } else {
                    $highLevelSearch.hide();
                }
                if (index === IS_SHOW_KJ_SEARCH) {
                    $microphone.show().attr('data-index', index);
                    $searchType.show();
                } else {
                    $microphone.hide();
                    $searchType.hide();
                }
                $("#_searchKeywords").val('');
                $("#_searchByKeywords").attr('data-type', index);
                __xushusSearch.resetHighSearchParam();
            }
        });
        __xushusSearch.clickCount = 0;
    }
};

$(() => {
    __xushusSearch.init();
    $(document)
        // 显示和隐藏高级搜索
        .on('click', '._advancedSearch', __xushusSearch.toggleAdvanceSearch)
        .on('click', '.radio-item', __xushusSearch.handleChangeRadio)
        .on('click', '.jxxq-1', __xushusSearch.showOpen1)
        .on('click', '.jxxq-2', __xushusSearch.showOpen2)
        .on('click', '.jxxq-3', __xushusSearch.showOpen3)
        .on('click','.closeJzimg',__xushusSearch.closeJz)
});